import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { ErrorPage } from '@edx/frontend-platform/react';
import {
  Button, Container, Row, Col,
} from '@openedx/paragon';
import messages from './messages';

import useTranslationInfo from '../utils/useTranslationInfo';
import { clearLocalStorageLanguage } from '../utils/localStorage';
import { translationPerformanceKeys, LONG_LOAD_NOTIFICATION_TIMEOUT } from '../utils/performance';

const TranslationsError = ({ courseId }) => {
  const { formatMessage } = useIntl();
  const { isTranslating } = useTranslationInfo(courseId);
  const [isTimeoutError, setIsTimeoutError] = useState(null);

  useEffect(() => {
    window.performance?.mark?.(translationPerformanceKeys.errorKey);
    const loadingMeasure = window.performance?.measure?.(
      translationPerformanceKeys.measureName,
      translationPerformanceKeys.loadKey,
      translationPerformanceKeys.errorKey,
    );
    setIsTimeoutError(loadingMeasure && loadingMeasure.duration > LONG_LOAD_NOTIFICATION_TIMEOUT);
  }, []);

  const reload = () => {
    window.location.reload();
  };

  const revertToOriginalLanguage = () => {
    clearLocalStorageLanguage(courseId);
    reload();
  };

  let errorMessage;
  if (isTimeoutError === null) {
    errorMessage = '';
  } else {
    let specificMessage;
    if (isTimeoutError) {
      specificMessage = formatMessage(messages.timeoutErrorMessage);
    } else {
      specificMessage = formatMessage(messages.errorMessage);
    }
    errorMessage = `${specificMessage} ${formatMessage(messages.commonErrorMessage)}`;
  }

  return isTranslating ? (
    <Container fluid className="py-5 justify-content-center align-items-start text-center" data-testid="error-page">
      <Row>
        <Col>
          <p className="text-muted">{ errorMessage }</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            className="mx-5 my-1"
            as="a"
            target="_blank"
            href="https://help.edx.org/edxlearner/s/contactsupport"
          >
            {formatMessage(messages.contactSupportButtonLabel)}
          </Button>
          <Button
            className="mx-5 my-1"
            onClick={revertToOriginalLanguage}
          >
            {formatMessage(messages.revertLanguageButtonLabel)}
          </Button>
        </Col>
      </Row>
    </Container>
  ) : (
    <ErrorPage />
  );
};

TranslationsError.propTypes = {
  courseId: PropTypes.string.isRequired,
};

export default TranslationsError;
